import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import * as userProfileActions from '../actions/user-profile.actions';
import { UserRestClient } from '../services/user-rest-client.service';
import { AppReadyGuard } from '../services/app-ready.guard';

import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/combineLatest';

/**
 * Effects handle user profile retrieval.
 */
@Injectable()
export class UserEffects {

    @Effect() loadUserProfile$ = this.actions$
        .ofType(userProfileActions.LOAD_REQUEST)
        .combineLatest(this.guard.waitForAppToBeReady(), a => a)
        .switchMap(() => this.loadUserProfile());

    /**
     * Function loads user profile and returns success / error action according to response.
     */
    private loadUserProfile = () => this.client.loadUserProfile()
        .map(payload => (new userProfileActions.LoadSuccessAction(payload)))
        .catch(error => Observable.of(new userProfileActions.LoadErrorAction(error)));

    constructor(private client: UserRestClient,
                private actions$: Actions,
                private guard: AppReadyGuard) {}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/effects/user.effects.ts